module.exports = __webpack_public_path__ + "static/img/irole.5179aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/xk/irole.png
// module id = 6gl2
// module chunks = 7